var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCatalogEmptyState = function SvgCatalogEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 126,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M181 51.168c0 49.935-36.673 102.542-85.876 58.077C45.921 64.779 0 101.103 0 51.168S39.63-14.074 73.938 13.79C108.245 41.656 181 1.233 181 51.168z",
    fill: props.accentFill
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 20h109v21H36V20zm-3 21V20a3 3 0 013-3h109a3 3 0 013 3v85a3 3 0 01-3 3H36a3 3 0 01-3-3V41zm112 3H36v61h109V44z",
    fill: "#363840"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 55.5,
    width: 31,
    height: 10,
    rx: 4.5,
    fill: "#363840",
    stroke: "#363840"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#363840",
    d: "M44.688 27.141h6v6h-6zM130.84 27.141h6v6h-6z"
  })));
};
export default SvgCatalogEmptyState;